module.exports = __webpack_public_path__ + "img/c3.d89ccc81.png";